export default Object.freeze({
    ASSAN: 'Assan',
    EVENTRAC: 'Eventrac',
});



// WEBPACK FOOTER //
// ./src/Assets/components/TenantConfigurations/consts/themes.js